import axios from 'axios';

// Base URLs - .env dosyasından al
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.trim();


const INTEGRATOR_CONFIG = {
  ModelType: parseInt(process.env.REACT_APP_INTEGRATOR_MODEL_TYPE),
  DatabaseName: process.env.REACT_APP_INTEGRATOR_DATABASE_NAME,
  UserGroupCode: process.env.REACT_APP_INTEGRATOR_USER_GROUP_CODE,
  UserName: process.env.REACT_APP_INTEGRATOR_USER_NAME,
  Password: process.env.REACT_APP_INTEGRATOR_PASSWORD,
};


// Token'ı saklamak için
let integratorToken = null;

// Store referansı - logout action için
let storeRef = null;
let logoutAction = null; // Logout action'ı dinamik olarak yüklenecek

// ✅ Duplicate Request Önleme - Pending request'leri sakla
// Key: requestKey, Value: { promise, timestamp }
const pendingRequests = new Map();

// ✅ ETag Cache - Response ETag'lerini sakla
const etagCache = new Map();
// ✅ Response Cache - 304 Not Modified için response data'yı sakla
const responseCache = new Map();

// ✅ Request performans ve tekrar takibi
const requestTimings = new Map(); // key -> start time
const requestCounts = new Map();  // key -> kaçıncı çağrı
const SLOW_REQUEST_THRESHOLD = 1200; // ms
const CRITICAL_REQUEST_THRESHOLD = 10000; // ms

const shouldLogDashboardTraffic = () => {
  if (typeof window === 'undefined') return false;
  const path = window.location?.pathname || '';
  return path.startsWith('/dashboard');
};

const logRequestResult = ({ config, response, error, meta = {} }) => {
  if (!shouldLogDashboardTraffic()) return;
  const key = config.__requestKey || getRequestKey(config);
  const method = (config.method || 'get').toUpperCase();
  const url = config.url || '';
  const start = config.__startTime || requestTimings.get(key);
  const end = (typeof performance !== 'undefined' ? performance.now() : Date.now());
  const durationMs = start ? Math.round(end - start) : null;
  const count = requestCounts.get(key) || 1;
  const isRepeat = count > 1;
  const status = response?.status || error?.response?.status || 'ERR';
  const statusText = response?.statusText || error?.message || 'Hata';
  const cacheHit = response?.status === 304 ? true : false;
  const slow = durationMs !== null && durationMs >= SLOW_REQUEST_THRESHOLD;
  const critical = durationMs !== null && durationMs >= CRITICAL_REQUEST_THRESHOLD;
  const sentETag = config.__sentETag || null;
  const receivedETag = meta.receivedETag || null;
  let etagDurumu = null;
  if (sentETag && receivedETag) {
    etagDurumu = sentETag === receivedETag ? 'ayni_ama_200' : 'degisti';
  } else if (sentETag && !receivedETag) {
    etagDurumu = 'gonderildi_ama_yanit_yok';
  } else if (!sentETag && receivedETag) {
    etagDurumu = 'yanit_var_gonderilmedi';
  }

  const payload = {
    zaman: new Date().toISOString(),
    istek: `${method} ${url}`,
    durum: status,
    aciklama: statusText,
    sureMs: durationMs,
    tekrarSayisi: count,
    tekrarMi: isRepeat,
    yavasMi: slow,
    kritikMi: critical,
    cache304: cacheHit,
    etagGonderildi: sentETag || undefined,
    etagYaniti: receivedETag || undefined,
    etagDurumu: etagDurumu || undefined,
  };

  void payload;
};

// ✅ Pending request temizleme - 30 saniye sonra otomatik temizle
const PENDING_REQUEST_TIMEOUT = 30000; // 30 saniye
setInterval(() => {
  const now = Date.now();
  for (const [key, value] of pendingRequests.entries()) {
    if (now - value.timestamp > PENDING_REQUEST_TIMEOUT) {
      pendingRequests.delete(key);
    }
  }
}, 10000); // Her 10 saniyede bir kontrol et

/**
 * Request key oluştur (URL + method + params + data)
 * Aynı request'leri tespit etmek için kullanılır
 */
function getRequestKey(config) {
  const { url, method = 'get', params, data } = config;
    
  // ✅ URL'den query parametrelerini parse et ve params ile birleştir
  let normalizedUrl = url || '';
  let allParams = params || {};
  
  // URL'de query parametreleri varsa (örn: /api/endpoint?param1=value1&param2=value2)
  const urlParts = normalizedUrl.split('?');
  if (urlParts.length > 1) {
    // Base URL'i al (query parametreleri olmadan)
    normalizedUrl = urlParts[0];
    
    // Query string'i parse et
    const queryString = urlParts[1];
    const urlParams = new URLSearchParams(queryString);
    
    // URL parametrelerini object'e çevir ve mevcut params ile birleştir
    const urlParamsObj = {};
    urlParams.forEach((value, key) => {
      urlParamsObj[key] = value;
    });
    
    // Mevcut params ile birleştir (config.params öncelikli)
    allParams = { ...urlParamsObj, ...allParams };
  }
  
  // Params'ı string'e çevir (sıralı ve normalize edilmiş)
  let paramsStr = '';
  if (Object.keys(allParams).length > 0) {
    // Object'i sıralı bir şekilde string'e çevir (key sırası önemli değil)
    const sortedKeys = Object.keys(allParams).sort();
    const sortedParams = {};
    sortedKeys.forEach(key => {
      sortedParams[key] = allParams[key];
    });
    paramsStr = JSON.stringify(sortedParams);
  }
  
  // Data'yı string'e çevir (sadece GET değilse)
  let dataStr = '';
  if (data && method.toLowerCase() !== 'get') {
    try {
      dataStr = JSON.stringify(data);
    } catch (e) {
      dataStr = String(data);
    }
  }
  
  return `${method.toUpperCase()}_${normalizedUrl}_${paramsStr}_${dataStr}`;
    }
    
/**
 * ETag key oluştur (URL + params)
 * getRequestKey ile aynı mantık - URL'den query parametrelerini parse et
 */
function getETagKey(config) {
  const { url, params } = config;
  
  // ✅ URL'den query parametrelerini parse et ve params ile birleştir
  let normalizedUrl = url || '';
  let allParams = params || {};
  
  // URL'de query parametreleri varsa (örn: /api/endpoint?param1=value1&param2=value2)
  const urlParts = normalizedUrl.split('?');
  if (urlParts.length > 1) {
    // Base URL'i al (query parametreleri olmadan)
    normalizedUrl = urlParts[0];
    
    // Query string'i parse et
    const queryString = urlParts[1];
    const urlParams = new URLSearchParams(queryString);
    
    // URL parametrelerini object'e çevir ve mevcut params ile birleştir
    const urlParamsObj = {};
    urlParams.forEach((value, key) => {
      urlParamsObj[key] = value;
    });
    
    // Mevcut params ile birleştir (config.params öncelikli)
    allParams = { ...urlParamsObj, ...allParams };
  }
  
  // Params'ı string'e çevir (sıralı ve normalize edilmiş)
  let paramsStr = '';
  if (Object.keys(allParams).length > 0) {
    // Object'i sıralı bir şekilde string'e çevir (key sırası önemli değil)
    const sortedKeys = Object.keys(allParams).sort();
    const sortedParams = {};
    sortedKeys.forEach(key => {
      sortedParams[key] = allParams[key];
    });
    paramsStr = JSON.stringify(sortedParams);
  }
  
  return `${normalizedUrl}_${paramsStr}`;
  }

// Store'u set et (App.js'den çağrılacak)
export const setStore = (store) => {
  storeRef = store;
  // Logout action'ını dinamik olarak import et (circular dependency'yi önlemek için)
  import('../slices/authSlice').then((module) => {
    logoutAction = module.logout;
  }).catch((error) => {
    // Hata sessizce yok sayılıyor
  });
};

// Axios instance oluştur
const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000, // 30 saniye (10 saniye çok kısa olabilir)
  headers: {
    'Content-Type': 'application/json',
    // Ngrok 403 uyarısını bypass etmek için zorunlu header
    'ngrok-skip-browser-warning': 'true',
  },
  // ✅ 304 Not Modified'ı başarılı kabul et (ETag caching için gerekli)
  validateStatus: (status) => {
    // 200-299: Başarılı
    // 304: Not Modified (cache hit - başarılı kabul et)
    // 400+: Hata
    return (status >= 200 && status < 300) || status === 304;
  },
});

// Request Interceptor - Her istekte çalışır
axiosInstance.interceptors.request.use(
  async (config) => {
    const requestUrl = config.url || '';
    const requestKey = getRequestKey(config);
    config.__requestKey = requestKey;
    config.__startTime = (typeof performance !== 'undefined' ? performance.now() : Date.now());
    requestTimings.set(requestKey, config.__startTime);
    requestCounts.set(requestKey, (requestCounts.get(requestKey) || 0) + 1);
    
    // Login ve logout endpoint'leri public endpoint'lerdir
    const isPublicEndpoint = 
      requestUrl.includes('/auth/login') || 
      requestUrl.includes('/auth/logout');
    
    // Token mekanizması kaldırıldı - Backend session cookie kullanıyor olabilir
    // Authorization header'ı eklenmiyor
    
    // ✅ Duplicate Request Önleme artık API wrapper'da yapılıyor
    // Interceptor'da sadece ETag desteği ve logging yapılıyor
    
    // ✅ ETag/If-None-Match Header Desteği
    // GET request'ler için cached ETag'i kullan
    if (config.method === 'get' || !config.method) {
      const etagKey = getETagKey(config);
      const cachedETag = etagCache.get(etagKey);
      
      if (cachedETag) {
        config.headers['If-None-Match'] = cachedETag;
        config.__sentETag = cachedETag;
      }
    }

    // FormData gönderimlerinde Content-Type'ı axios/browseer'ın boundary ile ayarlamasına izin ver
    // Aksi halde application/json kalırsa backend "file" alanını parse edemez.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
    }
    
    return config;
  },
  (error) => {
    // Duplicate request hatası ise, original promise'i döndür
    if (error.isDuplicate && error.originalPromise) {
      return error.originalPromise.then(() => {
        // Original promise tamamlandığında config'i döndür
        return error.config;
      });
    }
    
    return Promise.reject(error);
  }
);

// Response Interceptor - Her yanıtta çalışır
axiosInstance.interceptors.response.use(
  (response) => {
    const requestKey = getRequestKey(response.config);
    const etagKey = getETagKey(response.config);
    
    // ✅ Pending request temizleme artık API wrapper'da yapılıyor
    
    // ✅ ETag Cache - Response'dan ETag'i al ve cache'le
    // Axios header'ları normalize eder, tüm header'lar lowercase olur
    // Ancak bazı durumlarda orijinal case korunabilir, her iki durumu da kontrol et
                
    // ETag'i bul - tüm olası formatları kontrol et
    let etag = response.headers['etag'] || 
               response.headers['ETag'] || 
               response.headers['Etag'];
              
    // Eğer hala bulunamadıysa, header key'lerini case-insensitive kontrol et
    if (!etag) {
      const headerKeys = Object.keys(response.headers);
      const etagKey = headerKeys.find(key => key.toLowerCase() === 'etag');
      if (etagKey) {
        etag = response.headers[etagKey];
      }
    }
    
    if (etag && (response.config.method === 'get' || !response.config.method)) {
      // ETag'den tırnak işaretlerini temizle (bazı backend'ler "W/etag" formatında gönderebilir)
      const cleanETag = etag.replace(/^["']|["']$/g, '').trim();
      etagCache.set(etagKey, cleanETag);
      
      // ✅ 200 response'unda response data'yı cache'e kaydet (304 için kullanılacak)
      if (response.status === 200 && response.data) {
        responseCache.set(etagKey, response.data);
      }
      response.__cleanETag = cleanETag;
    }
                      
    // ✅ 304 Not Modified Response - Cache'den kullan
    if (response.status === 304) {
      // Cache'den önceki response data'yı al
      const cachedData = responseCache.get(etagKey);
      if (cachedData) {
        response.data = cachedData;
                      } else {
        response.data = null;
      }
    }
    logRequestResult({ config: response.config, response, meta: { receivedETag: response.__cleanETag } });
    return response;
  },
  (error) => {
    // ✅ Pending request temizleme artık API wrapper'da yapılıyor
    
    // ✅ 304 Not Modified - Bu bir hata değil, başarılı cache hit
    if (error.response?.status === 304) {
      // 304 response'u başarılı response'a çevir
      // Cache'den gelen veriyi kullan (eğer varsa) veya boş data döndür
      const successResponse = {
        ...error.response,
        status: 304,
        statusText: 'Not Modified',
        data: error.response?.data || null, // 304'te genellikle body yok
      };
      return Promise.resolve(successResponse);
    }
    
    // ✅ 409 Conflict — iş kuralı ihlali (örn. zamanlanmış/gönderilmiş bildirim silme)
    if (error.response?.status === 409) {
      error.userMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data?.note ||
        'Bu işlem mevcut durumda yapılamaz.';
    }

    // ✅ 400 Bad Request
    if (error.response?.status === 400) {
      const errorMsg = error.response?.data?.message || 
                      error.response?.data?.error || 
                      'Geçersiz istek. Lütfen gönderilen verileri kontrol edin.';
      error.userMessage = errorMsg;
    }
    
    // Timeout hatası kontrolü
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      const errorMsg = error.response?.data?.message || 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin veya daha sonra tekrar deneyin.';
      error.userMessage = errorMsg;
      
      // ✅ Pending request'i temizle (timeout olduğunda)
      if (error.config?.__requestKey) {
        const requestKey = error.config.__requestKey;
        pendingRequests.delete(requestKey);
      }
      
      return Promise.reject(error);
    }
    
    // Network hatası kontrolü
    if (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error')) {
      const errorMsg = 'Sunucuya erişilemiyor. Lütfen BACKEND_URL yapılandırmasını kontrol edin.';
      error.userMessage = errorMsg;
      
      // ✅ Pending request'i temizle (network hatası olduğunda)
      if (error.config?.__requestKey) {
        const requestKey = error.config.__requestKey;
        pendingRequests.delete(requestKey);
      }
      
      return Promise.reject(error);
    }
    
    // 401 Unauthorized - Token süresi dolmuş veya geçersiz
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isLoginEndpoint = requestUrl.includes('/auth/login');
      const isRefreshEndpoint = requestUrl.includes('/auth/refresh');
      const isIntegratorEndpoint = requestUrl.includes('IntegratorService');
      
      if (!isLoginEndpoint && !isRefreshEndpoint && !isIntegratorEndpoint) {
        // 401 hatası durumunda sadece hatayı döndür, logout yapma
        // Kullanıcı manuel logout yapmadığı sürece çıkmasın
      }
    }
    
    // 404 Not Found - Özel endpoint'ler için sessizce handle et
    if (error.response?.status === 404) {
      const requestUrl = error.config?.url || '';
      // Kullanıcı detay endpoint'i için özel işlem yapma, thunk içinde handle edilecek
      if (requestUrl.includes('/api/admin/dashboard/users/')) {
        // 404 hatasını reject et, thunk içinde handle edilecek
      }
    }
    
    // 500 Server Error
    if (error.response?.status >= 500) {
      const errorMsg = error.response?.data?.message || 'Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.';
      error.userMessage = errorMsg;
      
      // ✅ Pending request'i temizle (500 hatası olduğunda)
      if (error.config?.__requestKey) {
        const requestKey = error.config.__requestKey;
        pendingRequests.delete(requestKey);
      }
      
      // 500 hatası geçici bir hata olabilir, logout yapma
    }
    if (error.config) {
      logRequestResult({ config: error.config, error });
    }
    return Promise.reject(error);
  }
);

/**
 * ✅ Duplicate Request Önleme - API wrapper fonksiyonu
 * Aynı request pending ise, mevcut promise'i döndür
 */
function makeRequest(method, url, dataOrConfig, config) {
  // Config'i normalize et
  let finalConfig = {};
  let finalData = null;
  
  if (method === 'get' || method === 'delete') {
    // GET ve DELETE için: (url, config)
    finalConfig = dataOrConfig || {};
  } else {
    // POST, PUT, PATCH için: (url, data, config)
    finalData = dataOrConfig;
    finalConfig = config || {};
  }
  
  // Request key oluştur
  const requestConfig = {
    url,
    method,
    params: finalConfig.params,
    data: finalData,
  };
  const requestKey = getRequestKey(requestConfig);
  
  // Eğer aynı request pending ise, mevcut promise'i döndür
  if (pendingRequests.has(requestKey)) {
    const pendingRequest = pendingRequests.get(requestKey);
    const requestAge = Date.now() - pendingRequest.timestamp;
    
    // Eğer pending request çok eskiyse (30 saniye), temizle ve yeni request'e izin ver
    if (requestAge > PENDING_REQUEST_TIMEOUT) {
      pendingRequests.delete(requestKey);
    } else {
      // Mevcut pending promise'i döndür
      if (pendingRequest.promise) {
        return pendingRequest.promise;
      }
      // Promise henüz oluşmamışsa, pending request'i temizle ve yeni request'e izin ver
      pendingRequests.delete(requestKey);
    }
  }
  
  // Yeni request oluştur
  let requestPromise;
  switch (method) {
    case 'get':
      requestPromise = axiosInstance.get(url, finalConfig);
                        break;
    case 'post':
      requestPromise = axiosInstance.post(url, finalData, finalConfig);
                        break;
    case 'put':
      requestPromise = axiosInstance.put(url, finalData, finalConfig);
      break;
    case 'delete':
      requestPromise = axiosInstance.delete(url, finalConfig);
      break;
    case 'patch':
      requestPromise = axiosInstance.patch(url, finalData, finalConfig);
                        break;
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
  
  // ✅ Race condition önleme: Request'i Map'e eklemeden önce bir daha kontrol et
  // Eğer aynı anda başka bir request aynı key'i eklediyse, onu kullan
  if (pendingRequests.has(requestKey)) {
    const existingRequest = pendingRequests.get(requestKey);
    const existingAge = Date.now() - existingRequest.timestamp;
    
    if (existingAge <= PENDING_REQUEST_TIMEOUT && existingRequest.promise) {
      // Yeni oluşturduğumuz promise'i iptal et (axios cancel token ile)
      // Mevcut promise'i döndür
      return existingRequest.promise;
    }
  }
  
  // Pending request'i Map'e ekle
  pendingRequests.set(requestKey, {
    promise: requestPromise,
    timestamp: Date.now(),
  });
  
  // Request tamamlandığında (başarılı veya hatalı) pending request'i temizle
  // ⚠️ Bu yan zincirde hata tekrar fırlatılmamalı: kimse bu zinciri dinlemiyor,
  // fırlatılırsa her başarısız istek "unhandled rejection" olur (dev'de tam ekran overlay).
  // Hata, aşağıda döndürülen requestPromise üzerinden çağırana zaten ulaşıyor.
  requestPromise
    .then(() => {
      pendingRequests.delete(requestKey);
    })
    .catch((error) => {
      // Cancel hatası değilse temizle
      if (!axios.isCancel(error)) {
        pendingRequests.delete(requestKey);
      }
    });
  
  return requestPromise;
                }

// API fonksiyonları
export const api = {
  // GET request
  get: (url, config = {}) => makeRequest('get', url, config),
  
  // POST request
  post: (url, data = {}, config = {}) => makeRequest('post', url, data, config),
  
  // PUT request
  put: (url, data = {}, config = {}) => makeRequest('put', url, data, config),
  
  // DELETE request
  delete: (url, config = {}) => makeRequest('delete', url, config),
  
  // PATCH request
  patch: (url, data = {}, config = {}) => makeRequest('patch', url, data, config),
  
  // ✅ ETag Cache Temizleme - Belirli URL pattern'ine göre cache'i temizle
  clearETagCache: (urlPattern) => {
    if (!urlPattern) {
      // Eğer pattern verilmezse tüm cache'i temizle
      etagCache.clear();
      responseCache.clear();
      return;
                      }
                      
    // URL pattern'ine göre cache'i temizle
    for (const [key, value] of etagCache.entries()) {
      if (key.includes(urlPattern)) {
        etagCache.delete(key);
                  }
    }
    
    for (const [key, value] of responseCache.entries()) {
      if (key.includes(urlPattern)) {
        responseCache.delete(key);
      }
    }
  },
  
  // Integrator Service - Token Al (Backend Proxy üzerinden)
  getIntegratorToken: async () => {
    try {
      // Token varsa ve geçerliyse kullan
      if (integratorToken) {
        return integratorToken;
      }
      
      // Backend proxy endpoint'ini kullan (GET isteği)
      // Backend kendi integrator credentials'ını kullanarak token alacak
      const url = `${BACKEND_URL}/api/admin/dashboard/integrator/connect`;
      
      // axiosInstance kullan (Authorization header otomatik eklenir)
      const response = await axiosInstance.get(url);
      
      // Backend response formatı: { success: true, data: { token: "...", expiresIn: 3600, message: "..." } }
      if (response.data?.success && response.data?.data?.token) {
        // Token'ı sakla (eski format ile uyumlu olması için Token field'ı ekle)
        integratorToken = {
          Token: response.data.data.token,
          expiresIn: response.data.data.expiresIn,
          ...response.data.data
        };
      return integratorToken;
      }
      
      throw new Error('Backend response formatı beklenen formatta değil');
    } catch (error) {
      // Backend hataları için kullanıcı dostu mesaj
      if (error.response?.data?.message) {
        error.userMessage = error.response.data.message;
      } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
        error.userMessage = 'Integrator servisine bağlanılamadı. Lütfen daha sonra tekrar deneyin.';
      }
      
      throw error;
    }
  },

  // Integrator Service - Stored Procedure çağırma (Backend Proxy üzerinden)
  runProc: async (procName, parameters = []) => {
    try {
      // Integrator token al
      const integratorTokenData = await api.getIntegratorToken();
      
      // Backend proxy endpoint'ini kullan
      const url = `${BACKEND_URL}/api/admin/dashboard/integrator/proxy`;
      const body = {
        token: integratorTokenData.Token,
        procName: procName,
        parameters: parameters,
      };
      
      // axiosInstance kullan (Authorization header otomatik eklenir)
      const response = await axiosInstance.post(url, body);
      
      // Backend response formatı: { success: true, data: [...], message: "..." }
      if (response.data?.success && response.data?.data) {
        // Response'u eski format ile uyumlu hale getir (response.data.data'yı döndür)
        return {
          ...response,
          data: response.data.data,
        };
      }
      
      throw new Error('Backend response formatı beklenen formatta değil');
    } catch (error) {
      // Token hatası varsa, token'ı sıfırla ve tekrar dene
      if (error.response?.status === 401 || error.response?.status === 403) {
        integratorToken = null;
        
        // Bir kere daha dene
        try {
        const newToken = await api.getIntegratorToken();
          const retryBody = {
            token: newToken.Token,
            procName: procName,
            parameters: parameters,
          };
          
          const retryResponse = await axiosInstance.post(
            `${BACKEND_URL}/api/admin/dashboard/integrator/proxy`,
            retryBody
          );
          
          if (retryResponse.data?.success && retryResponse.data?.data) {
            return {
              ...retryResponse,
              data: retryResponse.data.data,
            };
          }
          
          throw new Error('Retry response formatı beklenen formatta değil');
        } catch (retryError) {
          throw retryError;
        }
      }
      
      // Backend hataları için kullanıcı dostu mesaj
      if (error.response?.data?.message) {
        error.userMessage = error.response.data.message;
      }
      
      throw error;
    }
  },
};

export default axiosInstance;

